var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcNetware(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2494_147713)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19 18.9998H1V1.00345H19V18.9998Z",
    fill: "#ED1C24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.99131 1L18.5234 3.38434L18.4215 3.47307L5.77881 1.00001H9.99172",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.57376 1.00253L17.0751 4.64706L16.9846 4.72603L2.3014 2.1341L1.28711 1.00257H3.5743",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6106 5.92209L15.5133 6.00691L4.25422 4.30059L2.50195 2.35736L15.6106 5.92214",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1596 7.18631C14.1435 7.21399 14.0942 7.25098 14.0583 7.27459L6.20466 6.46251L4.45801 4.52539L14.1597 7.18638",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6281 8.51938L12.5335 8.60176L8.15094 8.62318L6.41553 6.69846L12.6236 8.52328L12.6282 8.51936",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.33254 8.82254L11.2679 9.70488L10.0693 10.7487L8.33252 8.8226",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.68016 1.97736H1.62906V1.7884H1.62804L1.5602 1.97736H1.53002L1.46218 1.7884H1.46116V1.97736H1.41016V1.74316H1.49251L1.54529 1.88171L1.59802 1.74316H1.68042V1.97736H1.68016ZM1.38151 1.7884H1.31016V1.97736H1.25392V1.7884H1.18262V1.74317H1.38151L1.38151 1.7884Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.58105 14.6078L4.16846 17.4571V14.7806H4.59817V18.5526L2.01076 15.7031V18.4036H1.58105V14.6076",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.32814 17.3514C5.33296 17.7358 5.59251 18.0962 6.0059 18.0962C6.33748 18.0962 6.51538 17.928 6.67877 17.6589L7.0441 17.8655C6.8326 18.2548 6.43845 18.4806 6.00105 18.4806C5.31369 18.4806 4.89551 17.9616 4.89551 17.2985C4.89551 16.6066 5.26563 16.0876 5.99143 16.0876C6.70757 16.0876 7.04408 16.6162 7.04408 17.2841V17.3514L5.32814 17.3514ZM6.61151 17.0246C6.55864 16.6883 6.33749 16.4624 5.99147 16.4624C5.65501 16.4624 5.40507 16.7027 5.3522 17.0246H6.61153",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.56747 17.3756L10.5912 14.7039L11.6151 17.3756L12.6293 14.7808H13.1196L11.6151 18.548L10.5912 15.8908L9.56747 18.548L8.06299 14.7808H8.55325L9.56747 17.3756Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7925 18.4038H14.3598V18.053H14.3502C14.1772 18.3077 13.908 18.4806 13.5859 18.4806C12.8986 18.4806 12.5093 17.9088 12.5093 17.265C12.5093 16.6499 12.9178 16.0877 13.5716 16.0877C13.9032 16.0877 14.1724 16.2607 14.3502 16.5297H14.3598V16.155H14.7925V18.4038ZM14.3839 17.2794C14.3839 16.8421 14.1195 16.4721 13.6533 16.4721C13.2062 16.4721 12.9419 16.8613 12.9419 17.2794C12.9419 17.7022 13.1966 18.0962 13.6533 18.0962C14.1243 18.0962 14.3839 17.7214 14.3839 17.2794Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5698 16.5203H15.5842C15.69 16.256 15.9111 16.0878 16.1995 16.0878C16.3244 16.0878 16.4494 16.1311 16.5552 16.1983L16.3581 16.5923C16.2812 16.5251 16.1946 16.5011 16.0937 16.5011C15.6275 16.5011 15.5698 16.9335 15.5698 17.2987V18.4039H15.1372V16.155H15.5698V16.5202",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9121 17.3514C16.9169 17.7358 17.1764 18.0962 17.5898 18.0962C17.9215 18.0962 18.0993 17.928 18.2627 17.6589L18.628 17.8655C18.4165 18.2548 18.0224 18.4806 17.585 18.4806C16.8977 18.4806 16.4795 17.9616 16.4795 17.2985C16.4795 16.6066 16.8496 16.0876 17.5754 16.0876C18.2915 16.0876 18.628 16.6162 18.628 17.2841V17.3514L16.9121 17.3514ZM18.1954 17.0246C18.1425 16.6883 17.9214 16.4624 17.5754 16.4624C17.2389 16.4624 16.989 16.7027 16.9361 17.0246H18.1954Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.88237 18.4038H7.45108V16.5642H7.21631V16.1618H7.45108V15.454H7.88237V16.1618H8.30406V16.5642H7.88237V18.4038Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.1724 15.872C18.1724 15.7504 18.2686 15.653 18.3902 15.653C18.5113 15.653 18.6081 15.7504 18.6081 15.872C18.6081 15.9924 18.5113 16.0898 18.3902 16.0898C18.2687 16.0898 18.1724 15.9925 18.1724 15.872ZM18.5564 15.872C18.5564 15.7741 18.4838 15.7048 18.3902 15.7048C18.2951 15.7048 18.2241 15.7741 18.2241 15.872C18.2241 15.9688 18.2951 16.0381 18.3902 16.0381C18.4838 16.0381 18.5564 15.9688 18.5564 15.872ZM18.4948 15.9826H18.4397L18.3891 15.8868H18.3539V15.9826H18.3033V15.7559H18.4133C18.4656 15.7559 18.5014 15.7653 18.5014 15.8252C18.5014 15.867 18.4799 15.8841 18.4397 15.8868L18.4948 15.9826ZM18.4145 15.8527C18.4397 15.8527 18.4541 15.8472 18.4541 15.8186C18.4541 15.7955 18.4249 15.7955 18.4029 15.7955H18.3539V15.8527H18.4145Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2494_147713"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(1 1)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcNetware);
export default __webpack_public_path__ + "static/media/ic-netware.d6fd540b859107f1ac9b53d2203e42b9.svg";
export { ForwardRef as ReactComponent };